import React from "react";
import "./styles.scss";

const icon = require("../../assets/icons/scroll/dark.svg");

export default props => (
  <img className="scroll-icon" src={ icon } alt="scroll"/>
);
